class FormattingRuleService {
    private static _formattingRules: Array<FormattingRule> = null;
    static get allFormattingRules() {
        if (FormattingRuleService._formattingRules == null) {
            FormattingRuleService.getFormattingRules();
        }

        return FormattingRuleService._formattingRules;
    }
    static get formattingRules() {
        let formattingRules = FormattingRuleService.allFormattingRules;
        if (irSettings.multiTenant) {
            formattingRules = FormattingRuleService.allFormattingRules.filter(x => x.companyId == loggedUser.companyId() || (x.companyId == 0 && x.organisationId == 0) || (x.companyId == 0 && x.organisationId == loggedUser.orgId()));
        }

        return formattingRules;
    }
    static getFormattingRuleById = function (id: number) {

        let fr = FormattingRuleService.allFormattingRules.find(x => x.id === id);
        if (fr) {
            let copy = new FormattingRule(fr);
            return copy;
        }

        return null;
    }

    /**
     * Returns the formatting rule scale based on the value. 
     * The correct would be moving this to formatting rule class, but formattingRule might be a simple object here
     * @param formattingRule An object base on the FormattingRule class
     * @param value 
     * @param isPercent
     * @returns
     */
    static getFormattingRuleScale = function (formattingRule, value: number, isPercent: boolean = false) {
        if (value === null || value === undefined || formattingRule.scales.length === 0) {
            return null;
        }

        let outputScale = formattingRule.scales[0];
        for (var i = 0; i < formattingRule.scales.length; i++) {
            let scale = formattingRule.scales[i];
            if (scale.minValue > value * (isPercent ? 100 : 1)) {
                break;
            }

            outputScale = scale;
        }

        return outputScale;
    }

    static getColor(color: string, defaultColor: string = "unset") {
        if (!color || color.toLowerCase() === "transparent") {
            return defaultColor;
        }

        return color;
    }

    static getNewFormattingRule = function () {
        return new FormattingRule(null);
    }

    private static getFormattingRules() {
        let o = {
            url: urlConfigs.formattingRules + "Get",
            data: {},
            dataType: "json",
            async: false,
        } as RequestServerParams
        o.successFunction = function (data) {
            FormattingRuleService._formattingRules = createInstances(FormattingRule, data.formattingRules ?? []);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get formatting rules";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    private static _formattingRuleEditor: FormattingRuleEditorVM = null;
    static get formattingRuleEditor() {
        if (FormattingRuleService._formattingRuleEditor == null) {
            FormattingRuleService.getEditorInformation();
        }
        return FormattingRuleService._formattingRuleEditor;
    }

    private static getEditorInformation() {
        let o = {
            url: urlConfigs.formattingRules + "GetEditor",
            data: {},
            dataType: "json",
            async: false,
        } as RequestServerParams
        o.successFunction = function (data: FormattingRuleEditorVM) {
            if (irSettings.multiTenant) {
                if (data.companies) {
                    //distinc
                    const uniqueIds = [...new Set(data.companies.map(item => item.organisationId))];

                    const newRecords = uniqueIds.map(id => new Classes.Models.Company({
                        id: 0,
                        name: "",
                        organisationId: id
                    }));

                    data.companies = [new Classes.Models.Company({
                        id: 0,
                        name: "",
                        organisationId: 0
                    }), ...newRecords, ...data.companies];
                }

                if (data.organizations && loggedUser.permissions.editFormattingRules) {
                    data.organizations = [new Organization({ id: 0, name: "" }), ...data.organizations];
                }
            }
            FormattingRuleService._formattingRuleEditor = data;
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get formatting rule";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    private static popoverComponent: Ir.Components.FormattingRules.Popover.IFormattingRulePopover = null;
    static show($target, onSelect: (formattingRule: FormattingRule) => void) {
        if (FormattingRuleService.popoverComponent == null) {
            let $popover = $(`<formatting-rule-popover params="callback: getComponent"></formatting-rule-popover>`);
            $popover.appendTo('body');
            ko.applyBindings({
                getComponent(component: Ir.Components.FormattingRules.Popover.IFormattingRulePopover) {
                    FormattingRuleService.popoverComponent = component;
                    FormattingRuleService.popoverComponent.show($target, onSelect);
                }
            }, $popover[0]);
        }
        else {
            FormattingRuleService.popoverComponent.show($target, onSelect);
        }
    }

    private static popupComponent: Ir.Components.FormattingRules.Editor.IFormattingRuleEditor = null;
    static showEditor() {
        if (FormattingRuleService.popupComponent == null) {
            let $popover = $(`<formatting-rule-editor params="callback: getComponent"></formatting-rule-editor>`);
            $popover.appendTo('body');
            ko.applyBindings({
                getComponent(component: Ir.Components.FormattingRules.Editor.IFormattingRuleEditor) {
                    FormattingRuleService.popupComponent = component;
                    FormattingRuleService.popupComponent.show();
                }
            }, $popover[0]);
        }
        else {
            FormattingRuleService.popupComponent.show();
        }
    }
}